import { NewsCommentCreateRequestDto } from './news-comment-create.request.dto';

export type NewsCommentUpdateRequestDto = Partial<Omit<NewsCommentCreateRequestDto, 'parentCommentId'>>;
